import * as React from 'react';

import ClientStorage, { StorageTypes } from 'lib/ClientStorage';

import Knob from 'components/atoms/Knob';
import Bevel from 'components/helper/Bevel';

const ProgramHeaderStorage = new ClientStorage(StorageTypes.LOCAL);
const programHeaderDismissedKey = 'programHeaderDismissed';

type ProgramHeaderState = {
	shouldShowHeader: boolean;
};

type ProgramHeaderProps = {
	text: string;
	title: string;
};

export default class ProgramHeader extends React.Component<ProgramHeaderProps, ProgramHeaderState> {
	public state: ProgramHeaderState = {
		shouldShowHeader: !ProgramHeaderStorage.get(programHeaderDismissedKey),
	};

	public handleDismiss = () => {
		this.setState(
			{
				shouldShowHeader: false,
			},
			() => {
				ProgramHeaderStorage.set(programHeaderDismissedKey, true);
			}
		);
	};

	public render() {
		const { title, text } = this.props;
		const { shouldShowHeader } = this.state;

		return (
			<div className={`m-program-header${!shouldShowHeader ? ' state-m-program-header--hidden' : ''}`}>
				<div className="m-program-header__bg">
					<Bevel modifier="bottom-left" color="ffffff" />
				</div>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<h1 className="m-program-header__title">{title}</h1>
							<p className="m-program-header__text">{text}</p>
							<div className="m-program-header__close" onClick={this.handleDismiss}>
								<Knob
									modifier="filled-green-light"
									size="s"
									icon="close"
									// tslint:disable-next-line: jsx-no-bind
									onClick={this.handleDismiss}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
